import { TableCell, TableRow } from "@mui/material";
import { ReactComponent as DeleteIcon } from "assets/icons/deleteIcon.svg";
import React from "react";
import Link from "@mui/material/Link";
import { isoDateWithoutTimeZone } from "helpers/utils";
import HtmlTooltip from "components/Elements/HtmlTooltip";

const Row = ({ row, classes, onDeleteClick, isReadOnly }) => {
	return (
		<TableRow>
			<TableCell className="note-field" style={{ whiteSpace: "unset" }}>
				<HtmlTooltip title={row.filename} className="note-field">
					<Link
						href={row.documentURL}
						target="_blank"
						rel="noopener noreferrer"
						className="max-two-line new-link"
					>
						{row.filename}
					</Link>
				</HtmlTooltip>
			</TableCell>
			<TableCell style={{ width: "100px" }}>{row.name}</TableCell>
			<TableCell style={{ width: "100px" }}>
				{isoDateWithoutTimeZone(row.date + "Z")}
			</TableCell>

			{isReadOnly ? null : (
				<TableCell style={{ width: "50px" }}>
					<DeleteIcon className={classes.deleteIcon} onClick={onDeleteClick} />
				</TableCell>
			)}
		</TableRow>
	);
};

export default Row;
